/* eslint-disable max-classes-per-file */
import { Constructor } from '@utils/types/constructor.type';
import { BA_ROUTES } from './business-accounts.routes';

export function BARoutes<TBase extends Constructor>(Base: TBase = class {} as any) {
  return class extends Base {
    baRoutes = BA_ROUTES;
  };
}
